import type { Theme } from '@mui/material/styles';

/**
 * Colours for the Cmd/Ctrl+K search panel. Light mode keeps its fixed greys; dark mode takes the
 * theme's surface, text and divider tokens, as the light greys glare on a dark page and leave the
 * theme's (white) text unreadable on them.
 */
const systemSearchColours = (theme: Theme) => {
    const { palette } = theme;
    if (palette.mode === 'dark') {
        return {
            panel: palette.background.paper,
            panelBorder: `1px solid ${palette.divider}`,
            inputText: palette.text.primary,
            filter: palette.action.hover,
            filterText: palette.text.secondary,
            filterHover: palette.action.selected,
            filterHoverText: palette.text.primary,
            result: palette.background.paper,
            resultActive: palette.action.selected,
            resultBorder: palette.divider,
            breadcrumb: palette.text.secondary,
        };
    }
    return {
        panel: palette.grey['400'],
        panelBorder: 'none',
        inputText: 'white',
        filter: palette.grey[500],
        filterText: palette.grey[300],
        filterHover: palette.grey[600],
        filterHoverText: palette.grey[200],
        result: palette.grey['100'],
        resultActive: palette.grey['300'],
        resultBorder: palette.grey['500'],
        breadcrumb: '#6c6c6c',
    };
};

export default systemSearchColours;
